import React, {useEffect, useState} from 'react';
import {MultiSelect} from "primereact/multiselect";
import "./select.scss";
import {Dropdown} from "primereact/dropdown";

export function Select(props) {
    const [list, setList] = useState()
    const [value, setValue] = useState(props.value)

    useEffect(() => {
        if (props.select === 'multiple' && props.options) {
            let liste = [];
            props.options?.forEach(function (y) {
                    props.value?.forEach(function (x) {
                        if (y[props.item] === x[props.item]) {
                            liste.push(y);
                        }
                    })
                }
            );
            setList(liste);
        }
    }, [props.options,props.value]);

    function _handleChange(e) {
        setList(e.target.value)
        if (props.item) {
            var map = e.target.value.map(getMap);
            props.onChange(props.name, map)
        } else {
            props.onChange(e);
        }
    }

    function _handleChangeSingleSelect(e) {
        setValue(e.target.value)
        if(props.text==='number'){
            e.target.value=Number(e.target.value);
        }
        props.onChange(e);
    }

    function getMap(item) {
        let name = new Object();
        name[props.item] = item[props.item];
        return JSON.parse(JSON.stringify(name));
    }

    function getMapDefault(item) {
        let list = props.value;
        if (list.filter(e => e[props.item] === item).length > 0) {
            return item
        }
    }

    return (
        <div className="p-inputgroup  span-mrg-multi">
            {props.icon ? <span className="p-inputgroup-addon span-mrg-icon-multi ">
                                          <i className={props.icon}></i>
                            </span> : ''}
            <span className="p-float-label ">
                {props.select === 'multiple' ?
                    <MultiSelect
                        id={props.id}
                        name={props.name}
                        filter={false}
                        //display='chip'
                        disabled={props.readOnly}
                        optionLabel={props.optionLabel}
                        value={list}
                        className={props.icon ? ('select-item span-mrg-input-multi') : ('select-item span-mrg-input-multi-noIcon')}
                        options={props.options}
                        maxSelectedLabels={3}
                        scrollHeight={props.scrollHeight}
                        onSelect={props.onSelect}
                        onChange={_handleChange}
                    />
                    :
                    <Dropdown
                        id={props.id}
                        name={props.name}
                        value={value}
                        disabled={props.readOnly}
                        options={props.options}
                        onChange={_handleChangeSingleSelect}
                        onSelect={props.onSelect}
                        className={props.icon ? ('select-item span-mrg-input-multi') : ('select-item span-mrg-input-multi-noIcon')}
                        optionLabel={props.optionLabel}
                        optionValue={props.optionValue}
                        filter={false}
                        style={props.style}
                        required={props.required}
                        filterBy={props.filterBy}
                        text={props.text}
                    />
                }
                <label className='label' htmlFor={props.id}>{props.label}
                    {props.required ? <span className='validate_required'> *</span> : ''}
                    {props.validate ? <span className='validate_required'>{' ' + props.validate}</span> : ''}
            </label>
            </span>
        </div>
    );

}